import React from "react";
import styles from "./ServicesHome.module.css";
import ServiceHome from "../ServiceHome/ServiceHome";
import data from "./data";

const ServicesHome = () => {
    return (
        <div className={`container ${styles.contain} overflow-hidden pb-4`}>
            <p data-aos="slide-right" className={styles.heading}>
                Produk Kami
            </p>
            <div>
                <p
                    data-aos="slide-left"
                    className={`mx-auto ${styles.subHeading}`}
                >
                    Terjamin kualitasnya, tahan lama untuk segala kebutuhan proyek Anda
                </p>
            </div>

            <div className="d-none d-md-flex row">
                {data &&
                    data.map((x) => (
                        <div key={x.id} className="col-lg-4 col-md-6">
                            <ServiceHome
                                id={x.id}
                                heading={x.heading}
                                content={x.content}
                                to={x.to}
                                icon={x.icon}
                            />
                        </div>
                    ))}
            </div>

            <div className={`d-flex d-md-none ${styles.horizontalScroll}`}>
                {data &&
                    data.map((x) => (
                        <div key={x.id} className={styles.cardWrapper}>
                            <ServiceHome
                                id={x.id}
                                heading={x.heading}
                                content={x.content}
                                to={x.to}
                                icon={x.icon}
                            />
                        </div>
                    ))}
            </div>
        </div>
    );
};
export default ServicesHome;